<template>
  <header id="header">
    <h1>{{title}}</h1>
    <div class="menu">
      <a href class="home" @click.prevent="home">
        <img src="@/assets/img/home.png" alt="홈" />
      </a>
      <a href title="메뉴" class="back" @click.prevent="gobackward">
        <img src="@/assets/img/back.png" alt="메뉴" />
      </a>
    </div>
  </header>
</template>

<script>
export default {
  props: ["title"],
  methods: {
    toggleGnb: function() {
      this.$store.dispatch("toggleGnb");
    },
    home() {
      this.$router.push("/main");
    },
    gobackward() {
      this.$router.replace("/qna/fulllist");
    }
  }
};
</script>


<style lang="scss" scoped>
</style>